var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isParamsValid)?_c('layout',{staticClass:"search"},[_c('top',{attrs:{"slot":"top","mode":"bookings"},slot:"top"},[_c('record-notice')],1),_c('record-list'),_c('bottom',{attrs:{"slot":"bottom"},slot:"bottom"})],1):_c('error-view')}
var staticRenderFns = []

export { render, staticRenderFns }